﻿import {IDisposableLike} from "../../Tools/Disposable/IDisposableLike";
import {ITemplateModel} from "../../Model/Template/ITemplateModel";
import {TypeProcessEnum} from "../../Variables/TypeProcessEnum";
import {TypeContentEnum} from "../../Variables/TypeContentEnum";
import {NotificationHelper} from "../../Helper/NotificationHelper";

export class TemplateGeneraliteEditor implements IDisposableLike{
    #jqMainContainer: JQuery | undefined;
    #model: ITemplateModel | undefined;
    #kForm: kendo.ui.Form | undefined
    #jqFormContainer: JQuery | undefined

    constructor(options: ITemplateGeneraliteEditorOptions) {
        this.#jqMainContainer = options.jqMainContainer;
        this.#model = options.model;
    }

    public Init = () => {
        this.#buildHtml();
        this.#buildForm();
    }

    #buildHtml = () => {
        this.#jqFormContainer = $("<div></div>").appendTo(this.#jqMainContainer);
    }

    #buildForm =  () => {
        console.dir(this.#model);
        this.#kForm = this.#jqFormContainer.kendoForm({
            formData: this.#model,
            orientation: "vertical",
            size: "small",
            items: [
                {
                    field: "Nom",
                    label: "Nom",
                    validation: {required: true},
                },
                {
                    field: "Libelle",
                    label: "Libelle",
                    validation: {required: false},
                    editor: "TextArea",
                    editorOptions: {
                        size: "small",
                        rows: 5,
                        length: 800
                    }
                },
                {
                    field: "TypeProcessLibelle",
                    label: "Type de processus",
                    editor: "DropDownList",
                    validation: {required: true},
                    editorOptions: {
                        dataSource: TypeProcessEnum.Instance.GetListeLibelle
                            .map(x => x.text)
                    }
                },
                {
                    field: "TypeContentLibelle",
                    label: "Type de contenu",
                    editor: "DropDownList",
                    validation: {required: true},
                    editorOptions: {
                        dataSource: TypeContentEnum.Instance.GetListeLibelle
                            .map(x => x.text)
                    }
                },
                {
                    field: "Primarykey", label: "Id",
                    attributes: {"circ-id": "templateId"},
                    editorOptions: {
                        enable: true,
                        suffixOptions: {icon: "copy"}
                    }, validation: {required: false}
                },
            ],
            change: (e: kendo.ui.FormChangeEvent) => {
                this.#model[e.field] = e.value;

                switch (e.field) {
                    case "TypeProcessLibelle":
                        this.#model.TypeProcess = TypeProcessEnum.Instance.GetByLibelle(e.value);
                        break;
                    case "TypeContentLibelle":
                        this.#model.TypeContent = TypeContentEnum.Instance.GetByLibelle(e.value);
                        break;
                }
            }
        }).data("kendoForm");

        this.#formRemoveButton().then();
        
        const input = this.#kForm.element.find("[circ-id='templateId']");
        input.prop("disabled", true);
        input.siblings(".k-input-suffix").on("click", (e) => {
            navigator.clipboard.writeText(input.val().toString())
                .then(() => NotificationHelper.Instance.success("L'Id a été copié dans le presse-papier"));
        });
    }

    #formRemoveButton = async () => {
        this.#kForm.element.find(".k-form-buttons").remove();
    }
    
    public Dispose = () => {
        this.#kForm.destroy();
        this.#jqFormContainer.remove();
        this.#jqMainContainer.empty();  
        
    }
}

export interface ITemplateGeneraliteEditorOptions {
    jqMainContainer: JQuery;
    model: ITemplateModel;
}